<div class="root-div">
  <button
    #deleteButton
    type="button"
    pButton
    pRipple
    (click)="onDeleteClick($event)"
    pTooltip="Delete Item"
    tooltipPosition="bottom"
    class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
    <mat-icon>delete</mat-icon>
  </button>
</div>
